import { defineComponent as ee, watchEffect as oe, ref as z, inject as ne, toRef as re, computed as $, h as d } from "vue";
import le from "./ghl-ui.es960.js";
import ce from "./ghl-ui.es961.js";
import { checkboxGroupInjectionKey as de } from "./ghl-ui.es267.js";
import ae from "./ghl-ui.es962.js";
import { useRtl as te } from "./ghl-ui.es875.js";
import { warnOnce as ie } from "./ghl-ui.es877.js";
import se from "./ghl-ui.es878.js";
import ue from "./ghl-ui.es901.js";
import fe from "./ghl-ui.es726.js";
import be from "./ghl-ui.es720.js";
import M from "./ghl-ui.es879.js";
import { createKey as T } from "./ghl-ui.es404.js";
import { useThemeClass as he } from "./ghl-ui.es881.js";
import { createId as me } from "./ghl-ui.es963.js";
import { resolveWrappedSlot as ke } from "./ghl-ui.es884.js";
import { on as ve } from "./ghl-ui.es724.js";
import ge from "./ghl-ui.es929.js";
import Ce from "./ghl-ui.es964.js";
import { call as D } from "./ghl-ui.es907.js";
const xe = Object.assign(Object.assign({}, M.props), {
  size: String,
  checked: {
    type: [Boolean, String, Number],
    default: void 0
  },
  defaultChecked: {
    type: [Boolean, String, Number],
    default: !1
  },
  value: [String, Number],
  disabled: {
    type: Boolean,
    default: void 0
  },
  indeterminate: Boolean,
  label: String,
  focusable: {
    type: Boolean,
    default: !0
  },
  checkedValue: {
    type: [Boolean, String, Number],
    default: !0
  },
  uncheckedValue: {
    type: [Boolean, String, Number],
    default: !1
  },
  "onUpdate:checked": [Function, Array],
  onUpdateChecked: [Function, Array],
  // private
  privateInsideTable: Boolean,
  // deprecated
  onChange: [Function, Array]
}), Pe = ee({
  name: "Checkbox",
  props: xe,
  setup(o) {
    process.env.NODE_ENV !== "production" && oe(() => {
      o.onChange && ie("checkbox", "`on-change` is deprecated, please use `on-update:checked` instead.");
    });
    const h = z(null), {
      mergedClsPrefixRef: i,
      inlineThemeDisabled: m,
      mergedRtlRef: x
    } = se(o), k = ue(o, {
      mergedSize(e) {
        const {
          size: c
        } = o;
        if (c !== void 0)
          return c;
        if (r) {
          const {
            value: l
          } = r.mergedSizeRef;
          if (l !== void 0)
            return l;
        }
        if (e) {
          const {
            mergedSize: l
          } = e;
          if (l !== void 0)
            return l.value;
        }
        return "medium";
      },
      mergedDisabled(e) {
        const {
          disabled: c
        } = o;
        if (c !== void 0)
          return c;
        if (r) {
          if (r.disabledRef.value)
            return !0;
          const {
            maxRef: {
              value: l
            },
            checkedCountRef: t
          } = r;
          if (l !== void 0 && t.value >= l && !a.value)
            return !0;
          const {
            minRef: {
              value: f
            }
          } = r;
          if (f !== void 0 && t.value <= f && a.value)
            return !0;
        }
        return e ? e.disabled.value : !1;
      }
    }), {
      mergedDisabledRef: v,
      mergedSizeRef: g
    } = k, r = ne(de, null), n = z(o.defaultChecked), R = re(o, "checked"), y = fe(R, n), a = be(() => {
      if (r) {
        const e = r.valueSetRef.value;
        return e && o.value !== void 0 ? e.has(o.value) : !1;
      } else
        return y.value === o.checkedValue;
    }), p = M("Checkbox", "-checkbox", ae, Ce, o, i);
    function C(e) {
      if (r && o.value !== void 0)
        r.toggleCheckbox(!a.value, o.value);
      else {
        const {
          onChange: c,
          "onUpdate:checked": l,
          onUpdateChecked: t
        } = o, {
          nTriggerFormInput: f,
          nTriggerFormChange: S
        } = k, b = a.value ? o.uncheckedValue : o.checkedValue;
        l && D(l, b, e), t && D(t, b, e), c && D(c, b, e), f(), S(), n.value = b;
      }
    }
    function s(e) {
      v.value || C(e);
    }
    function V(e) {
      if (!v.value)
        switch (e.key) {
          case " ":
          case "Enter":
            C(e);
        }
    }
    function B(e) {
      switch (e.key) {
        case " ":
          e.preventDefault();
      }
    }
    const I = {
      focus: () => {
        var e;
        (e = h.value) === null || e === void 0 || e.focus();
      },
      blur: () => {
        var e;
        (e = h.value) === null || e === void 0 || e.blur();
      }
    }, N = te("Checkbox", x, i), w = $(() => {
      const {
        value: e
      } = g, {
        common: {
          cubicBezierEaseInOut: c
        },
        self: {
          borderRadius: l,
          color: t,
          colorChecked: f,
          colorDisabled: S,
          colorTableHeader: b,
          colorTableHeaderModal: _,
          colorTableHeaderPopover: E,
          checkMarkColor: K,
          checkMarkColorDisabled: F,
          border: U,
          borderFocus: O,
          borderDisabled: P,
          borderChecked: j,
          boxShadowFocus: H,
          textColor: A,
          textColorDisabled: L,
          checkMarkColorDisabledChecked: G,
          colorDisabledChecked: W,
          borderDisabledChecked: q,
          labelPadding: J,
          labelLineHeight: Q,
          labelFontWeight: X,
          [T("fontSize", e)]: Y,
          [T("size", e)]: Z
        }
      } = p.value;
      return {
        "--n-label-line-height": Q,
        "--n-label-font-weight": X,
        "--n-size": Z,
        "--n-bezier": c,
        "--n-border-radius": l,
        "--n-border": U,
        "--n-border-checked": j,
        "--n-border-focus": O,
        "--n-border-disabled": P,
        "--n-border-disabled-checked": q,
        "--n-box-shadow-focus": H,
        "--n-color": t,
        "--n-color-checked": f,
        "--n-color-table": b,
        "--n-color-table-modal": _,
        "--n-color-table-popover": E,
        "--n-color-disabled": S,
        "--n-color-disabled-checked": W,
        "--n-text-color": A,
        "--n-text-color-disabled": L,
        "--n-check-mark-color": K,
        "--n-check-mark-color-disabled": F,
        "--n-check-mark-color-disabled-checked": G,
        "--n-font-size": Y,
        "--n-label-padding": J
      };
    }), u = m ? he("checkbox", $(() => g.value[0]), w, o) : void 0;
    return Object.assign(k, I, {
      rtlEnabled: N,
      selfRef: h,
      mergedClsPrefix: i,
      mergedDisabled: v,
      renderedChecked: a,
      mergedTheme: p,
      labelId: me(),
      handleClick: s,
      handleKeyUp: V,
      handleKeyDown: B,
      cssVars: m ? void 0 : w,
      themeClass: u == null ? void 0 : u.themeClass,
      onRender: u == null ? void 0 : u.onRender
    });
  },
  render() {
    var o;
    const {
      $slots: h,
      renderedChecked: i,
      mergedDisabled: m,
      indeterminate: x,
      privateInsideTable: k,
      cssVars: v,
      labelId: g,
      label: r,
      mergedClsPrefix: n,
      focusable: R,
      handleKeyUp: y,
      handleKeyDown: a,
      handleClick: p
    } = this;
    (o = this.onRender) === null || o === void 0 || o.call(this);
    const C = ke(h.default, (s) => r || s ? d("span", {
      class: `${n}-checkbox__label`,
      id: g
    }, r || s) : null);
    return d("div", {
      ref: "selfRef",
      class: [`${n}-checkbox`, this.themeClass, this.rtlEnabled && `${n}-checkbox--rtl`, i && `${n}-checkbox--checked`, m && `${n}-checkbox--disabled`, x && `${n}-checkbox--indeterminate`, k && `${n}-checkbox--inside-table`, C && `${n}-checkbox--show-label`],
      tabindex: m || !R ? void 0 : 0,
      role: "checkbox",
      "aria-checked": x ? "mixed" : i,
      "aria-labelledby": g,
      style: v,
      onKeyup: y,
      onKeydown: a,
      onClick: p,
      onMousedown: () => {
        ve("selectstart", window, (s) => {
          s.preventDefault();
        }, {
          once: !0
        });
      }
    }, d("div", {
      class: `${n}-checkbox-box-wrapper`
    }, " ", d("div", {
      class: `${n}-checkbox-box`
    }, d(ge, null, {
      default: () => this.indeterminate ? d("div", {
        key: "indeterminate",
        class: `${n}-checkbox-icon`
      }, ce) : d("div", {
        key: "check",
        class: `${n}-checkbox-icon`
      }, le)
    }), d("div", {
      class: `${n}-checkbox-box__border`
    }))), C);
  }
});
export {
  xe as checkboxProps,
  Pe as default
};
